import React, { lazy, Suspense, useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Header } from "../components/header";
// import { Footer } from "../components/footer";
import { SareeSubCategory } from "./SareeSubCategory";
import { Saree } from "./SareeCategory/Index";
import { Login } from "./Login/Login";
import { Signup } from "./Signup/Signup";
import { Services } from "./Services/index";
import { About } from "./About";
import { Contact } from "./Contact";
import { Profile } from "./Profile";
import { ShoppingCart } from "./Cart";
import { Checkout } from "./Cart/Checkout";
import { Fabrics } from "./Fabrics/Fabrics";
import { Forgot } from "./Forgot/Forgot";
import { Otp } from "./OTP/Otp";
import Preloader from "../components/preloader";

const Home = lazy(() => import("./Home/index"));
const Footer = lazy(() => import("../components/footer"));

export const Layout = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Hide preloader after 3 seconds
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
  const location = useLocation();

  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/signup" ||
    location.pathname === "/forgot" ||
    location.pathname === "/otp";

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <div>
          {!isAuthPage && <Header />}
          <main>
            <Suspense fallback={<Preloader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/saree" element={<Saree />} />
                <Route
                  path="/sareesubcategory"
                  element={<SareeSubCategory />}
                />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/forgot" element={<Forgot />} />
                <Route path="/services" element={<Services />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/cart" element={<ShoppingCart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/fabrics" element={<Fabrics />} />
                <Route path="/otp" element={<Otp />} />
              </Routes>
            </Suspense>
          </main>
          {!isAuthPage && <Footer />}
        </div>
      )}
    </>
  );
};
